import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Result } from 'antd';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import { useIdentity } from 'src/core/services/authentication';

const UnauthorizedPage: FC = () => {
  const identity = useIdentity();
  const { t } = useTranslation();
  setHeader(t('Unauthorized'));
  setRoutes([]);
  const [count, setCount] = useState(20);
  useEffect(() => {
    const timer = setInterval(() => {
      if (count === 1) {
        identity.logout();
      }
      setCount(count - 1);
    }, 1000);
    return () => timer && clearInterval(timer);
  });

  return <Result status="error" title={t('YouDontHaveAccessToSite')} subTitle={t('LoginOutInSecondsParam').replace('{0}', `${count}s`)} />;
};

export default UnauthorizedPage;
